import { trpc } from './trpc'
import { inferRouterOutputs, inferRouterInputs } from '@trpc/server'
import { AppRouter } from '@tagadapay/trpc-types'

type OutputRouter = inferRouterOutputs<AppRouter>
type InputRouter = inferRouterInputs<AppRouter>

// Output types
export type CurrencyRate = OutputRouter['currencyRates']['getStoreBaseCurrencyRate']

// Input types
export type GetStoreBaseCurrencyRateInput = InputRouter['currencyRates']['getStoreBaseCurrencyRate']

// Hook to get currency rates for a store's base currency
export function useStoreBaseCurrencyRate(storeId: string, enabled = true) {
    return trpc.currencyRates.getStoreBaseCurrencyRate.useQuery(
        { storeId },
        {
            enabled: enabled && !!storeId,
            staleTime: 1000 * 60 * 60, // 1 hour - exchange rates don't change that often
            refetchInterval: 1000 * 60 * 60, // Refetch every hour
        }
    )
}

